import { URLS } from "@app/shared";
import { Button, Link } from "@design-system/components";
import { trans } from "@mongez/localization";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import type { SectorData } from "../data";

interface SectorContentProps {
  sector: SectorData;
  isHovered: boolean;
}

export function SectorContent({ sector, isHovered }: SectorContentProps) {
  return (
    <AnimatePresence>
      {isHovered && (
        <motion.div
          initial={{ y: "100%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "100%", opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className="absolute inset-0 mb-8 flex flex-col justify-end p-4 text-white max-sm:mb-1 lg:mb-14 lg:p-6"
        >
          <div
            className="mb-5 h-[6px] w-full max-w-[544px] rounded-full lg:max-w-[80%]"
            style={{ backgroundColor: sector.color }}
          />
          <h3
            className="mb-1 text-2xl font-bold sm:text-3xl lg:text-4xl xl:text-5xl"
            style={{
              fontSize: "clamp(1.5rem, 4vw, 64px)",
            }}
          >
            {trans(sector.titleKey)}
          </h3>
          <p className="w-full max-w-[517px] text-lg font-medium sm:text-xl">
            {trans(sector.descriptionKey)}
          </p>

          <Link to={URLS.sectors.view(sector.to)}>
            <Button
              variant="outline"
              className="mt-6 h-12 w-40 min-w-max gap-2 rounded-full bg-[#FFFFFF29] text-sm font-bold uppercase text-white hover:bg-[#FFFFFF29] lg:mt-[36px] lg:h-[60px] lg:w-[188px] lg:text-base"
              rightIcon={<ChevronRight className="rtl:rotate-180" />}
            >
              <span className="block ltr:mt-1">
                {trans("ourSectors.learnMore")}
              </span>
            </Button>
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
